import { Injectable } from 'framework/di';

import { Platform } from './platform.interface';
import { ShopifyPlatform } from './shopify/platform';

@Injectable
export class PlatformLoader {
  platform!: Platform;

  constructor(private shopifyPlatform: ShopifyPlatform) {
    if (window.Shopify) {
      this.platform = this.shopifyPlatform;
    }
  }
}
